import { requiresAuth, requiresTerms } from "@/middleware";

const AuthView = () => import("./AuthView.vue");
const ResetPasswordView = () => import("./ResetPasswordView.vue");
const SetPasswordView = () => import("./SetPasswordView.vue");
const ResetPassword = () => import("@/components/auth/ResetPassword.vue");
const ResetPasswordForm = () => import("@/components/auth/ResetPasswordForm.vue");
const TermsView = () => import("./TermsView.vue");
const UserShippingAddressView = () => import("./UserShippingAddressView.vue");
const CreateAccountView = () => import("./CreateAccountView.vue");
const ActivateAccountView = () => import("./ActivateAccountView.vue");
const AuthenticateAccountView = () => import("./AuthenticateAccountView.vue");
const VerifyEmailView = () => import("./VerifyEmailView.vue");
const VerifyEmailRequired = () => import("@/components/auth/VerifyEmailRequired.vue");

const authRoutes = [
  {
    path: "/auth",
    name: "Auth",
    component: AuthView,
    props: true,
    meta: {}
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPasswordView,
    meta: {},
    children: [
      {
        path: "",
        name: "ResetPasswordRequest",
        component: ResetPassword
      },
      {
        path: ":token",
        name: "ResetPasswordForm",
        component: ResetPasswordForm,
        props: true
      }
    ]
  },
  {
    path: "/set-password",
    name: "SetPassword",
    component: SetPasswordView,
    meta: {
      middleware: [requiresAuth, requiresTerms]
    }
  },
  {
    path: "/terms",
    name: "Terms",
    component: TermsView,
    props: true,
    meta: {
      middleware: [requiresAuth]
    }
  },
  {
    path: "/shipping-address",
    name: "UserShippingAddress",
    component: UserShippingAddressView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms]
    }
  },
  {
    path: "/create-account",
    name: "CreateAccount",
    component: CreateAccountView,
    props: false,
    meta: {}
  },
  {
    path: "/authenticate-account",
    name: "AuthenticateAccount",
    component: AuthenticateAccountView,
    meta: {}
  },
  {
    path: "/activate-account/:token",
    name: "ActivateAccount",
    component: ActivateAccountView,
    props: true,
    meta: {}
  },
  {
    path: "/verify-email",
    name: "VerifyEmail",
    component: VerifyEmailView,
    meta: {
      middleware: [requiresAuth, requiresTerms]
    },
    children: [
      {
        path: "",
        name: "VerifyEmailRequired",
        component: VerifyEmailRequired
      },
      {
        path: ":token",
        name: "VerifyEmailRequiredToken",
        component: VerifyEmailRequired,
        props: true
      }
    ]
  }
];

export default authRoutes;
